export const environment = {
  APP_ROOT: "/",
  SOCKET_HOST: "https://guestlist.heartland.us",
};



/** WEBPACK FOOTER **
 ** ./src/environments/environment.prod.js
 **/